import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '角色大全', to: '/characters' },
  { label: '声优表', to: '/voice-actors' },
  { label: '关于本站', to: '/about' },
];

const factions = [
  { label: '守护者', to: '/characters' },
  { label: '复活社', to: '/characters' },
  { label: '守护甜心', to: '/characters' },
];

export default function Footer() {
  return (
    <footer className="mt-16 w-full bg-background-200/80 border-t border-background-300/70">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="sm:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-heart-3-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-base font-bold text-foreground-900">守护甜心档案</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-foreground-600">
              守护甜心动漫角色大全与声优表资料站，集中收录日奈森亚梦、月咏几斗、边里唯世等主要角色的背景故事，以及守护甜心动漫配音演员与角色对照信息。想查角色、对声优，来这里就好。
            </p>
          </div>

          <nav aria-label="快速导航">
            <h3 className="font-heading text-sm font-bold text-foreground-900">快速导航</h3>
            <ul className="mt-4 space-y-2.5">
              {quickLinks.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    <i className="ri-arrow-right-s-line text-primary-400" aria-hidden="true"></i>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="分类导航">
            <h3 className="font-heading text-sm font-bold text-foreground-900">角色阵营</h3>
            <ul className="mt-4 space-y-2.5">
              {factions.map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-600"
                  >
                    <i className="ri-sparkling-2-line text-primary-400" aria-hidden="true"></i>
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-300/70 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 守护甜心档案 · 仅供动漫爱好者交流整理，与版权方无关
          </p>
          <p className="flex items-center gap-1.5 text-xs text-foreground-500">
            <i className="ri-heart-line text-primary-400" aria-hidden="true"></i>
            以热爱致敬每一位角色与声优
          </p>
        </div>
      </div>
    </footer>
  );
}